export default "__VITE_ASSET__CrcYe681__"